import { createTheme } from '@fluentui/react'

export const leobitTheme = createTheme({
  palette: {
    themePrimary: '#198754',
    themeLighterAlt: '#e8fff8',
    themeLighter: '#baffea',
    themeLight: '#2dfcbe',
    themeTertiary: '#2fd6a4',
    themeSecondary: '#20c997',
    themeDarkAlt: '#198754',
    themeDark: '#198754',
    themeDarker: '#3d7d1f',
    neutralLighterAlt: '#faf9f8',
    neutralLighter: '#f3f2f1',
    neutralLight: '#edebe9',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralQuaternary: '#ffffff',
    neutralTertiaryAlt: '#c8c6c4',
    neutralTertiary: '#a19f9d',
    neutralSecondary: '#605e5c',
    neutralPrimaryAlt: '#3b3a39',
    neutralPrimary: '#323130',
    neutralDark: '#201f1e',
    black: '#000000',
    white: '#ffffff'
  },
  semanticColors: {
    bodyBackground: "transparent"
  }
})
